<template>
  <main-template>
    <v-row>
      <v-col>
        <span class="text-h4">
          <v-btn color="primary" x-small text @click="() => $router.push({ name: 'alunos' })">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Histórico acadêmico -
          <span class="text-h5">
            {{ aluno.nomecompleto ? aluno.nomecompleto : " " }}
          </span>
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <div class="d-flex mb-2 justify-start">
          <v-btn color="success" @click="adicionarHistorico" class="mr-2"
            >Adicionar histórico <v-icon class="ml-2">mdi mdi-plus-circle</v-icon></v-btn
          >
          <v-btn color="success" @click="baixarHistorico" class="mr-2"
            >Baixar Historico <v-icon class="ml-2">mdi mdi-download-circle</v-icon></v-btn
          >
          <v-text-field
            v-model="search"
            class="ml-auto search-input"
            append-icon="mdi-magnify"
            label="Pesquisar..."
            solo
            autofocus
            dense
            single-line
            hide-details
          />
        </div>
      </v-col>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="historicoList"
          :items-per-page="20"
          :custom-filter="dataTableFilter"
          :search="search"
          hide-default-footer
          class="elevation-1"
          :loading="carregandoHistorico"
        >
          <template v-slot:progress>
            <v-progress-linear
              height="4"
              indeterminate
              color="primary"
              :active="carregandoHistorico"
            ></v-progress-linear>
          </template>

          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr color="primary" v-for="item of items" :key="item.id" class="text-uppercase">
                <td class="text-lowercase">{{ item.id }}</td>
                <td>{{ item.serie ?? "- - -" }}</td>
                <td>{{ item.estabelecimento ? item.estabelecimento : "- - -" }}</td>
                <td>{{ item.cidade ? item.cidade : "- - -" }}</td>
                <td>{{ item.ano ? item.ano : "- - -" }}</td>
                <td>
                  <div v-if="item.flag" class="d-flex">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          class="ml-1"
                          color="blue-grey lighten-3"
                          v-bind="attrs"
                          v-on="on"
                          @click="() => editarHistorico(item.id)"
                        >
                          <v-icon small>fa fa-edit </v-icon>
                        </v-btn>
                      </template>
                      <span>Editar Historico</span>
                    </v-tooltip>
                    <v-tooltip color="error" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          class="ml-1"
                          color="error"
                          v-bind="attrs"
                          v-on="on"
                          @click="() => deletarHistorico(item.id)"
                        >
                          <v-icon small>fa fa-trash </v-icon>
                        </v-btn>
                      </template>
                      <span>Apagar Historico</span>
                    </v-tooltip>
                  </div>
                  <div v-else class="text-left">
                    <span class="text-caption grey--text"> Matrícula do sistema </span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small color="grey" v-bind="attrs" v-on="on" class="ml-1">
                          mdi-information
                        </v-icon>
                      </template>
                      <span
                        >Esta matrícula foi gerada pelo sistema, a edição não é permitida em
                        históricos.</span
                      >
                    </v-tooltip>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>

          <template v-slot:no-data>
            <div v-if="carregandoHistorico" class="text-center py-4">
              <v-progress-circular
                indeterminate
                color="primary"
                size="32"
                class="mb-2"
              ></v-progress-circular>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </main-template>
</template>

<script lang="js">
import { dataTableFilter } from "@/plugins/searchQuery";

export default {
  data() {
    return {
      carregandoHistorico: false,
      dataTableFilter,
      search: "",
      aluno: "",
      historicoList: [],
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Serie", value: "serie" },
          { text: "Estabelecimento", value: "estabelecimento" },
          { text: "Cidade", value: "municipio" },
          { text: "Ano de Conclusão", value: "ano" },
          { text: "Ações", value: "actions", sortable: false },
        ],
      },
    };
  },
  mounted() {
    this.carregarHistorico(this.$router.currentRoute.params.aluno_id);
  },
  methods: {
    async carregarHistorico(aluno_id) {
      this.carregandoHistorico = true;

      this.$loaderService.open("Carregando histórico...");

      try {
        this.historicoList = [];

        const [response] = await Promise.all([
          this.$services.historicoService.syncAll(aluno_id),
          new Promise(resolve => setTimeout(resolve, 3000))
        ]);

        this.aluno = response.aluno;

        const externos = response.historicoExterno.map((item) => ({
          id: item.id,
          serie: item.serie?.descricao ?? "-",
          ano: item.ano,
          estabelecimento: item.estabelecimento,
          cidade: item.cidade,
          flag: true,
        }));

        const sistema = response.historicoDoSistema.map((item) => ({
          id: item.id,
          serie: item?.turma?.series[0]?.descricao ?? item?.turma?.descricao ?? "-",
          ano: item?.ano?.descricao ?? "-",
          estabelecimento: item?.turma?.franquia?.descricao ?? "-",
          cidade: item?.turma?.franquia?.cidade ?? "-",
          flag: false,
          ultimaSubetapaId: item.ULTIMA_SUBETAPA_CIRCUITO_ID ?? null,
        }));

        this.historicoList = this.ordenarHistoricoPorSerie([...externos, ...sistema]);

      } catch (error) {
        this.$toast.danger("Erro ao carregar histórico.");
        console.error(error);
      } finally {
        this.carregandoHistorico = false;
        this.$loaderService.close();
      }
    },

    ordenarHistoricoPorSerie(lista) {
      return lista.sort((a, b) => {
        const ordemA = a.serie?.ordem ?? 999;
        const ordemB = b.serie?.ordem ?? 999;
        if (ordemA !== ordemB) {
          return ordemA - ordemB;
        }
        const normalizar = (serie) => (serie ?? "").toString().trim();
        const serieA = normalizar(a.serie?.descricao || a.serie);
        const serieB = normalizar(b.serie?.descricao || b.serie);

        if (!serieA && !serieB) return 0;
        if (!serieA) return 1;
        if (!serieB) return -1;

        return serieA.localeCompare(serieB, "pt-BR", {
          sensitivity: "base",
        });
      });
    },

    adicionarHistorico() {
      this.$router.push({ name: "historico.create" });
    },

    editarHistorico(historico_id) {
      this.$router.push({ name: "historico.edit", params: { historico_id } });
    },

    async deletarHistorico(historico_id) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar este item?",
        confirmationCode: historico_id,
        confirmationMessage: `Por favor, digite <strong>${historico_id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando item do histórico");
              try {
                await this.$services.historicoService.deletarItem(historico_id);
                this.$toast.success("Histórico deletado com sucesso");

                await this.carregarHistorico(this.$router.currentRoute.params.aluno_id);
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              small: true,
            },
          },
        ],
      });
    },

    async baixarHistorico() {
      try {
        this.$loaderService.open("Gerando Histórico...");
        await this.$services.historicoService.baixarHistorico(this.$router.currentRoute.params.aluno_id);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style>
.v-data-table__progress {
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>
